import { computed } from 'vue';

import tt from '@/i18n/utils/translateText';
import { DEFAULT_PASSWORD_COMPLEXITY_SETTINGS, generatePasswordRules } from '@/domains/generatePasswordRules';
import { useUserStore } from '@/stores/user';
import { useTenantsStore } from '@/stores/tenants';
import { TComplexityCheck } from '@/contexts/accountingContext/domain/types';

const requiredRule = {
  required: true,
  message: tt('shared.rule.passwordRequired'),
  trigger: 'blur',
};

export const useInfrastructureConstants = () => {
  const userStore = useUserStore();
  const tenantsStore = useTenantsStore();

  const complexityCheck = computed<TComplexityCheck>(() => tenantsStore.getTenantComplexityCheck
      || userStore.user?.ownerTenantSettings?.passwordComplexitySettings?.complexityCheck
      || DEFAULT_PASSWORD_COMPLEXITY_SETTINGS);

  const updatePasswordRules = computed(() => ({
    oldPassword: [
      requiredRule,
    ],
    newPassword: [
      requiredRule,
      ...generatePasswordRules(complexityCheck.value),
    ],
  }));

  const resetPasswordRules = computed(() => ({
    password: [
      requiredRule,
      ...generatePasswordRules(complexityCheck.value),
    ],
  }));

  return {
    updatePasswordRules,
    resetPasswordRules,
  };
};
